// extracted by mini-css-extract-plugin
module.exports = {"control":"styles_control__ulsDR","icon":"styles_icon__7H9Kc"};